import { Component, OnInit, inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-msal-callback',
  standalone: true,
  template: `
    <div style="display:flex; align-items:center; justify-content:center; height:100vh; background:#000;">
      <p style="color:#fff; font-size:14px; font-family:sans-serif;">Autenticando con Microsoft...</p>
    </div>
  `
})
export class MsalCallbackComponent implements OnInit {
  private readonly msalService = inject(MsalService, { optional: true });

  async ngOnInit(): Promise<void> {
    if (!this.msalService) {
      return;
    }

    try {
    
      await this.msalService.instance.handleRedirectPromise();
    } catch (error) {
      console.error('[MSAL Callback] Error procesando redirect:', error);
    }
  }
}